export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ContactInfo.vue?vue&type=template&id=2639042e&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/ContactInfo.vue?vue&type=template&id=2639042e&scoped=true
// module id = 310
// module chunks = 0